import PaxContactConfirm from '@/views/PaxContactConfirm/index.vue'

const PaxContactConfirmRouter = {
  path: '/pax-contact-confirm',
  name: 'PaxContactConfirm',
  component: PaxContactConfirm,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default PaxContactConfirmRouter
